import {
  FieldType,
  MobxFieldControl
} from '@app/src/common/components/form/MobxFieldControl';
import { IFormField } from '@app/src/common/model/FormField';
import { FormControlType } from '@app/src/common/model/FormControls';

export default class DynamicFormControl extends MobxFieldControl {
  config: IFormField;

  constructor(config: IFormField) {
    super(config.defaultValue, config.type);
    this.config = config;

    if (
      config.defaultValue &&
      config.type === FieldType.ARRAY &&
      [FormControlType.AUTOCOMPLETE, FormControlType.SELECT].includes(
        config.control
      )
    ) {
      this.defaultValue = config.defaultValue ? config.defaultValue[0] : '';
      this._value = this.defaultValue;
    }
  }
}
